import {isChristmasSeason, isHalloweenSeason} from '@Utils/seasonal-promotion.util';

export enum SeasonName {
  HALLOWEEN = 'HALLOWEEN',
  CHRISTMAS = 'CHRISTMAS',
}

export const getCurrentSeasonName = (): SeasonName | undefined => {
  if (isHalloweenSeason()) {
    return SeasonName.HALLOWEEN;
  }

  if (isChristmasSeason()) {
    return SeasonName.CHRISTMAS;
  }

  return undefined;
};

/**
 * The season the stock panel is currently dressed for, or null when today falls outside every
 * season window (plans/seasonal-stock.md). Every part of the feature — the seasonal pill, the
 * season request param, the in-season carousel order — reads this, so the season windows govern
 * them together.
 */
export const getActiveStockSeason = (): SeasonName | null => {
  return getCurrentSeasonName() ?? null;
};
